import CalculationDropdown from './CalculationDropdown'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { useDispatch, useSelector } from 'react-redux'
import { FancyRadio } from 'apps/builder/components/settings/modal'
import { CalculationFormatDropdown } from './FormatDropdown'
import { SumSettings } from './Sum'
import { allEntryTypesSelector } from 'apps/builder/store/selectors'
import SparklesIcon from 'apps/builder/assets/sparkles.svg'
import { WhiteLabelCheck } from 'apps/builder/components/shared'

const TableCalculations = {
  Sum: SumSettings,
}

const CalculationInterface = ({ entry }) => (
  <div className="calculation--settings">
    <CalculationDropdown {...entry} />
    <CalculationFormatDropdown {...entry} />
  </div>
)

const TableCalculationInterface = ({ entry }) => {
  const { type } = entry
  const TableCalculationSettings =
    TableCalculations[type] || TableCalculations['Sum']
  return <TableCalculationSettings {...entry} />
}

const getCalculationConfiguration = type => {
  const configurations = {
    Calculation: CalculationInterface,
    'Table Calculation': TableCalculationInterface,
  }

  return configurations[type] || configurations['Calculation']
}

export const Calculation = entry => {
  const { guid, type } = entry
  const dispatch = useDispatch()
  const entryTypes = useSelector(allEntryTypesSelector)
  const calculationEntryType = entryTypes.find(
    ({ type }) => type === 'Calculation'
  )
  const sumEntryType = entryTypes.find(({ type }) => type === 'Sum')

  const calculationType =
    type === 'Calculation' ? 'Calculation' : 'Table Calculation'

  const CalculationConfiguration = getCalculationConfiguration(calculationType)
  const changeFieldType = ({
    id,
    original_type_id,
    placeholder: newPlaceholder,
    ...type
  }) => {
    dispatch(
      updateEntry({
        ...entry,
        ...type,
        entry_type_id: id,
        original_type_id: original_type_id,
        placeholder: newPlaceholder,
      })
    )
  }

  return (
    <div className="calculation-field--container">
      {sumEntryType && (
        <div className="calculation--options">
          <FancyRadio
            id={`${guid}-1`}
            label={'Calculation'}
            selected={calculationType}
            value={'Calculation'}
            onChange={(checked, value) => {
              checked ? changeFieldType(calculationEntryType) : ''
            }}
          />
          <FancyRadio
            id={`${guid}-2`}
            label={'Table Calculation'}
            selected={calculationType}
            value={'Table Calculation'}
            onChange={(checked, value) => {
              checked ? changeFieldType(sumEntryType) : ''
            }}
          />
          {type !== 'Calculation' && (
            <ul className="table-calculation--options">
              <li className="table-calculation--option">
                <FancyRadio
                  id={`${guid}-3`}
                  label={'Sum'}
                  selected={type}
                  value={'Sum'}
                  onChange={(checked, value) => {
                    checked ? changeFieldType(sumEntryType) : ''
                  }}
                />
              </li>
              <li className="table-calculation--option">
                <FancyRadio
                  id={`${guid}-4`}
                  label={'Average'}
                  selected={type}
                  value={'Average'}
                  disabled={true}
                />
                <div className="setting--label">
                  Coming Soon!
                  <SparklesIcon className="label--icon" />
                </div>
              </li>
              <li className="table-calculation--option">
                <FancyRadio
                  id={`${guid}-5`}
                  label={'Count'}
                  selected={type}
                  value={'Count'}
                  disabled={true}
                />
                <div className="setting--label">
                  Coming Soon!
                  <SparklesIcon className="label--icon" />
                </div>
              </li>
            </ul>
          )}
          <div className="foundry--surface surface--info info--block">
            <p>
              Calculations allow you to do complex mathematical functions and
              pull forward a sum of numbers from tables.
            </p>
            <WhiteLabelCheck>
              <a
                href="https://help.gocanvas.com/hc/en-us/articles/25489314937367-Setting-Up-a-Calculation-Field-in-the-Builder"
                target="_blank"
                className="info--block--link"
              >
                Learn More
              </a>
            </WhiteLabelCheck>
          </div>
        </div>
      )}
      <CalculationConfiguration entry={entry} />
    </div>
  )
}
